'use client'

// Theme provider removed - forcing light theme only
export function ThemeProviders({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
